<div class="expandable-table-container mat-elevated-item border rounded">
  <table class="w-100">
    <thead>
      <tr>
        @if (expandable()) {
          <th class="s-w-5"></th>
        }
        @if (allowSelection()) {
          <th class="s-w-5">
            <mat-checkbox
              color="primary"
              [checked]="isAllSelected()"
              [indeterminate]="isPartiallySelected()"
              (change)="onSelectAll($event.checked)"
            ></mat-checkbox>
          </th>
        }
        @for (col of columns(); track $index) {
          <th class="text-center">{{ col.name | translate }}</th>
        }
        @if (actions().length) {
          <th class="text-center">{{ 'COMMON.ACTIONS' | translate }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of items(); track $index; let i = $index) {
        <tr
          [ngClass]="{
            'expanded-row': expandedRows.has(row),
            'cursor-pointer': expandable(),
          }"
          (click)="expandable() ? toggleRow(row) : null"
        >
          @if (expandable()) {
            <td class="text-center">
              <mat-icon class="arrow-icon">{{
                expandedRows.has(row) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
              }}</mat-icon>
            </td>
          }
          @if (allowSelection()) {
            <td (click)="$event.stopPropagation()">
              <mat-checkbox
                color="primary"
                [checked]="row.selected"
                (change)="onSelectionChange(row, $event.checked)"
              ></mat-checkbox>
            </td>
          }
          @for (col of columns(); track $index) {
            <td class="text-center">
              <app-table-cell [column]="col" [row]="row" [index]="i"></app-table-cell>
            </td>
          }
          @if (actions().length) {
            <td (click)="$event.stopPropagation()">
              <div class="d-flex align-items-center justify-content-center">
                @for (act of actions(); track $index) {
                  <app-action-button
                    [row]="row"
                    [action]="act"
                    (actionClick)="emitAction($event, i)"
                  >
                  </app-action-button>
                }
              </div>
            </td>
          }
        </tr>

        @if (expandedRows.has(row)) {
          <tr>
            <td
              [attr.colspan]="
                columns().length +
                (allowSelection() ? 1 : 0) +
                (expandable() ? 1 : 0) +
                (actions().length ? 1 : 0)
              "
              class="p-0 border-0"
            >
              <div class="expansion-container p-4">
                <ng-container *ngTemplateOutlet="expansionTemplate; context: { $implicit: row }">
                </ng-container>
              </div>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>

  @if (showPaginator() && paginationForm()) {
    <app-paginator
      [total]="totalItems()"
      [inputMode]="'items'"
      [paginationFormGroupRef]="$any(paginationForm())"
    >
    </app-paginator>
  }
</div>
